export const getCookieConsent = (cookies) => {
  if (!cookies || !cookies.CookieConsent) {
    return {
      consentPayload: '',
      consentCaptureAd: false,
      consentCaptureAnalytics: false,
    };
  }

  const cookieConsent = cookies.CookieConsent.slice(1, -1)
    .split(',')
    .reduce(
      (acc, pair) => {
        const [key, value] = pair.split(':');
        acc[key] = value;

        return acc;
      },
      { ad_storage: 'denied', analytics_storage: 'denied' }
    );

  return {
    consentPayload: cookies.CookieConsent,
    consentCaptureAd: cookieConsent.ad_storage === 'granted',
    consentCaptureAnalytics: cookieConsent.analytics_storage === 'granted',
  };
};
